import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { isAuthenticated } from "../services/auth";

import Index from "../pages/Index";
import MenuRapido from "../pages/MenuRapido";
import PrivateRoute from "./private";
import PublicRoute from "./public";
import App from "../pages/App";
import Usuarios from "../pages/Usuarios";
import Estabelecimentos from "../pages/Estabelecimentos";
import Profissionais from "../pages/Profissionais";
import Vagas from "../pages/Vagas";
import Push from "../pages/Push";

export const Routes = () => {
  return (
    <BrowserRouter basename={'/admin'}>
      <Switch>  
        <PrivateRoute exact path="/Usuarios" component={Usuarios} />
        <PrivateRoute exact path="/Estabelecimentos" component={Estabelecimentos} />
        <PrivateRoute exact path="/Profissionais" component={Profissionais} />
        <PrivateRoute exact path="/Vagas" component={Vagas} />
        <PrivateRoute exact path="/Push" component={Push} />        
        <PrivateRoute exact path="/MenuRapido" component={MenuRapido} />
        <PublicRoute exact path="/" component={Index} />       
        <PublicRoute exact path="/esquecisenha/:token" component={Index} />
        <PublicRoute exact path="/cadastro/:token" component={Index} />
        <PublicRoute exact path="/app" component={App} />
        <PublicRoute path="*" component={() => <h1>Pagina não encontrada!</h1>} />
      </Switch>
    </BrowserRouter>
  );
}

export default Routes;